module.exports = __webpack_public_path__ + "img/iconLiShiYuanLiaoDaoZha.61a84293.svg";